// Standard auth headers for session-scoped API calls.
//
// The backend's get_authenticated_user accepts (in priority order) the
// X-Guest-User-Id header, the session_token cookie (sent via
// credentials: 'include'), or an Authorization: Bearer token. This mirrors the
// inline pattern used across the session components so every owner-scoped fetch
// presents the same identity. Always pair with `credentials: 'include'`.

import { clientHeaders } from './clientHeaders';

export function authHeaders(extra = {}) {
  const token = localStorage.getItem('jyotish_session_token');
  const guestUserId = localStorage.getItem('guest_user_id');
  const headers = {
    'Content-Type': 'application/json',
    ...clientHeaders(),
    ...extra,
  };
  if (token) headers['Authorization'] = `Bearer ${token}`;
  if (guestUserId) headers['X-Guest-User-Id'] = guestUserId;
  return headers;
}

export default authHeaders;
